import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class SizeGuideDrawerComponent extends DialogComponent {
  /** @type {HTMLButtonElement | null} */
  #actionButton = null;

  connectedCallback() {
    super.connectedCallback?.();
    this.#actionButton = this.querySelector('[ref="addToCartButton"]');
    this.#actionButton?.addEventListener('click', () => this.#handleActionClick());
  }

  open() {
    /** @type {any} */ (this.querySelector('pdp-size-guide-component'))?.syncFromPdp();
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  scrollToTop() {
    const content = this.querySelector('.size-guide-drawer__content');
    content?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async addToCart() {
    const button = this.#actionButton;
    if (!button) return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;

    try {
      const body = JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: this.#getSectionRenderingIds(),
      });

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body,
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.description || 'Add to cart failed');

      document.dispatchEvent(
        new CartAddEvent(data, this.id, {
          source: 'size-guide-drawer',
          variantId,
          sections: data.sections,
        }),
      );

      button.disabled = false;
      await this.closeDialog();
    } catch (error) {
      console.error('[SizeGuideDrawer] Add to cart error:', error);
      button.disabled = false;
    }
  }

  #handleActionClick() {
    const state = this.#actionButton?.getAttribute('data-button-state');

    if (state === 'select') {
      this.scrollToTop();
    } else if (state === 'add') {
      this.addToCart();
    } else if (state === 'notify') {
      this.#triggerBackInStock();
    }
  }

  #triggerBackInStock() {
    const bisButton = document.querySelector('#klaviyo-bis-button-container button');
    if (bisButton) {
      this.closeDialog();
      bisButton.click();
    }
  }

  #getSectionRenderingIds() {
    const sectionElements = document.querySelectorAll('[data-section-rendering-id]');
    return [...sectionElements].map((el) => el.getAttribute('data-section-rendering-id'));
  }
}

if (!customElements.get('size-guide-drawer-component')) {
  customElements.define('size-guide-drawer-component', SizeGuideDrawerComponent);
}
